import 'notyf/notyf.min.css'
import 'graphiql/graphiql.css'
import '@graphiql/plugin-explorer/dist/style.css'
import './global.css'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Amplify } from 'aws-amplify'
import posthog from 'posthog-js'
import { PostHogProvider } from '@posthog/react'
import { PostHogErrorBoundary } from 'posthog-js/react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { RecoilRoot } from 'recoil'

import getAppRouter from './app.router'
import { SchemaDesignerProvider } from './components/schema-designer/schema-designer-context'
import UploadFileStatusProvider from './pages/files/upload-file-status-provider'
import { getAmplifyConfig } from './utils/auth/amplify-config'
import AuthContextProvider from './utils/auth/auth-context'

const amplifyConfig = getAmplifyConfig()
Amplify.configure(amplifyConfig)

posthog.init(import.meta.env.NEXT_PUBLIC_POSTHOG_TOKEN, {
  api_host: import.meta.env.NEXT_PUBLIC_POSTHOG_HOST,
  defaults: '2026-01-30',
  disable_session_recording: true,
})

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      retry: 2,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <RecoilRoot>
    <QueryClientProvider client={queryClient}>
      <AuthContextProvider>
        <UploadFileStatusProvider>
          <SchemaDesignerProvider>
            <PostHogProvider client={posthog}>
              <PostHogErrorBoundary>
                <RouterProvider router={getAppRouter()} />
              </PostHogErrorBoundary>
            </PostHogProvider>
          </SchemaDesignerProvider>
        </UploadFileStatusProvider>
      </AuthContextProvider>
    </QueryClientProvider>
  </RecoilRoot>,
)
